module.exports = __webpack_public_path__ + "img/formats-3.9f6aebc9.png";